module.exports = __webpack_public_path__ + "static/img/1017.0753a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/totalBattery/1017.png
// module id = jUBO
// module chunks = 68